import React from 'react'

const Folder = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path d="M1.5 11.25H10.5C11.3273 11.25 12 10.5773 12 9.75V3.75C12 2.92266 11.3273 2.25 10.5 2.25H6.75C6.51328 2.25 6.29062 2.13984 6.15 1.95L5.7 1.35C5.41641 0.972656 4.97109 0.75 4.5 0.75H1.5C0.672656 0.75 0 1.42266 0 2.25V9.75C0 10.5773 0.672656 11.25 1.5 11.25Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)
export default Folder;
